module.exports = __webpack_public_path__ + "img/216909f.png";